module.exports = __webpack_public_path__ + "static/media/Source Info.518269fb.txt";